import "./style.scss";
import { Timeline as AntTimeline } from "antd";
import dayjs from "dayjs";

function Timeline({ data }) {
  return (
    <AntTimeline
      items={data.map((item) => ({
        children: (
          <div className="flex flex-col gap-2">
            <span className="timeline-content timeline-time">{item?.date}</span>
            <span className="timeline-content">{item?.description}</span>
          </div>
        ),
      }))}
    />
  );
}

export default Timeline;
